import { c as _c } from "react/compiler-runtime";
import { type LogoProps } from './types';
import { StyledLabelContainer, StyledContainer } from './styles';
import Icon from './assets/Icon';
import Label from './assets/Label';
const Logo = t0 => {
  const $ = _c(10);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  let logoWidth;
  let labelHeight;
  let labelPaddingLeft;
  bb0: switch (size) {
    case "large":
      {
        logoWidth = "32";
        labelHeight = "18";
        labelPaddingLeft = "28px";
        break bb0;
      }
    case "medium":
      {
        logoWidth = "20";
        labelHeight = "14";
        labelPaddingLeft = "18px";
        break bb0;
      }
    case "small":
      {
        logoWidth = "12";
        labelHeight = "10";
        labelPaddingLeft = "12px";
      }
  }
  let t2;
  if ($[0] !== logoWidth) {
    t2 = <Icon width={logoWidth} />;
    $[0] = logoWidth;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== labelHeight) {
    t3 = <Label height={labelHeight} />;
    $[2] = labelHeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== labelPaddingLeft || $[5] !== t3) {
    t4 = <StyledLabelContainer paddingLeft={labelPaddingLeft}>{t3}</StyledLabelContainer>;
    $[4] = labelPaddingLeft;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <StyledContainer>{t2}{t4}</StyledContainer>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default Logo;
export { Logo };